<template>
  <div class="app-config-loader flex-column justify-content-center align-items-center d-flex">
    <BImg src="/loading.gif" fluid alt="Responsive image" width="400" height="300"></BImg>
    <h5 class="text-muted loading-text">{{ loadingMessage }}</h5>
  </div>
</template>

<script lang="ts">
import { oidcChannel } from "@/core/broadcast/broadcast";
import { defineComponent } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ActivateTenant",
  data() {
    return {
      route: useRoute(),
      loadingMessage: "Activating Tenant..."
    };
  },
  async mounted(): Promise<void> {
    const organisationId = this.route.params.organisationId;
    const tenantId = this.route.params.tenantId;
    const accountType = this.route.params.accountType ?? "";

    await (this as any).$store.dispatch("removeOidcUser").then(async () => {
      oidcChannel.postMessage("activate-tenant-initialized");
      await (this as any).$store.dispatch("authenticateOidc", {
        redirectPath: "/dashboard",
        options: {
          extraQueryParams: { reqOrganisationId: organisationId, reqTenantId: tenantId, reqAccountType: accountType }
        }
      });
    });
  }
});
</script>
<style lang="scss" scoped>
.app-config-loader {
  background-color: #fff;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
}

.loading-text {
  position: absolute;
  top: calc(50% + 50px);
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
